import { createVNode as e, mergeProps as a } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/HttpNotFound2TwotoneStandard.js";
import p from "../components/PfIcon.js";
const t = (o, r) => {
  const n = {
    ...o,
    ...r.attrs
  };
  return e(p, a(n, {
    icon: d
  }), null);
};
t.displayName = "HttpNotFound2TwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
